import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { defaultLocale, resources } from "./translations";

const storedLocale =
  typeof window !== "undefined"
    ? (window.localStorage.getItem("app.locale") as keyof typeof resources | null)
    : null;

const initialLocale = storedLocale && resources[storedLocale] ? storedLocale : defaultLocale;

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLocale,
  fallbackLng: defaultLocale,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
